import script from "./TSInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./TSInvoice.vue?vue&type=script&setup=true&lang=ts"

import "./TSInvoice.vue?vue&type=style&index=0&id=4ca41c12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca41c12"]])

export default __exports__